var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-container" },
    [
      _c("div", { attrs: { id: "map-root" } }),
      _c("switch-control", {
        ref: "control",
        attrs: { outerLayers: _vm.layers },
        on: {
          switchMap: _vm.switchMap,
          switchObjectLayer: _vm.switchObjectLayer,
          switchCombinedLayer: _vm.switchCombinedLayer,
          zoomIn: _vm.zoomIn,
          zoomOut: _vm.zoomOut,
          measure: _vm.measure,
          measureClear: _vm.measureClear
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }